// extracted by mini-css-extract-plugin
export default {"ssoForm":"AKnjmbrR","input-container":"RdSasJC7","inputContainer":"RdSasJC7","button-container":"IcvXps52","buttonContainer":"IcvXps52"};